module.exports = __webpack_public_path__ + "img/transfer12.360fb7ae.jpeg";